export default __webpack_public_path__ + "static/media/1821.135bce2e.png";